<template>
  <main class="container">
      <div class="page achievement">
          <section class="page__intro">
            <h1 class="page__title">Dina uppfyllda mål</h1>
            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus quis felis elit. Maecenas fermentum ante non ligula tincidunt, eget gravida nulla tempus.</p>
          </section>
          <section>
              <p>Mina pensionsmål</p>
              <span class="f5">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus quis felis elit. Maecenas fermentum ante non ligula tincidunt, eget gravida nulla tempus.</span>
              <div>
                  <label>29 000 kr/månaden (nuvarande prognos)</label>
                  <label>MITT mål: 42 250 kr/månaden</label>
                  <div>
                      <div :style="style"></div>
                      <label>13 250 kr kvar</label>
                  </div>
              </div>
              <div>
                  <div>
                      <label>Privat sparande</label>
                      <div><div :style="{width:'50%',background:'#0066A1'}"></div></div>
                      <Button msg="Visa förslag"></Button>
                  </div>
                  <div>
                      <label>Tjänstepension</label>
                      <div><div :style="{width:'70%',background:'#8F3EF9'}"></div></div>
                      <Button msg="Visa förslag"></Button>
                  </div>
                  <div>
                      <label>Allmän pension</label>
                      <div><div :style="{width:'100%',background:'#D8B9FF'}"></div></div>
                  </div>
              </div>
          </section>
          <section>
              <p>Beräknad tid till pension</p>
              <div>
                  <div :style="{width:'60%'}">
                      <span>Du är {{user.age}} år</span>
                  </div>
                  <span>{{65 - user.age}} år kvar</span>
              </div>
          </section>
          <section>
              <p>Aktivt just nu (kontinuerlig bevakning)</p>
              <span class="f5">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus quis felis elit. Maecenas fermentum ante non ligula tincidunt, eget gravida nulla tempus.</span>
              <div>
                  <div class="checked"></div>
                  <span>Tjänstepension</span>
              </div>               
              <div>
                  <div class="checked"></div>
                  <span>Månadssparande</span>
              </div>               
              <div>
                  <div class="checked"></div>
                  <span>Livförsäkring</span>
                  <router-link to="/">Se villkor</router-link>
              </div>               
              <div>
                  <div class="unchecked"></div>
                  <span>Sjukförsäkring</span>
                  <router-link to="/">Teckna</router-link>
              </div>               
          </section>
      </div>
  </main>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import Button from '../components/elements/Button';

export default {
    name:"Achievement",
    data(){
        return{
            style:{"background" :`linear-gradient(90deg,#D8B9FF ${60}% , #8F3EF9 ${80}% , #0066A1 ${100}% )`,"width":"70%"}
        }
    },
    components : {
        Button
    },
    computed: {
        ...mapGetters(['user'])
    },
    methods: {
    },
    created() {
    }

}

</script>
